import React from "react";

const TopHeader = () => {
    return (
        <div className="bg-dark">
            <img src="../images/logo.png" className="mt-3 movie-logo" alt="Loader" />
            <h3 className="text-white p-2 m-0 text-center">Crypto App</h3>
        </div>
    );
};

export default TopHeader;
